import React from "react";
import UserNotFound from "../NotFound/UserNotFound";
import DefaultTemplate from "../UserPreviewTemplate/DefaultTemplate";
import Template1 from "../UserPreviewTemplate/Template1";
import Template2 from "../UserPreviewTemplate/Template2";

const UserViewSection = ({ profileData, selectedTemplate }) => {
  if (!profileData) {
    return <UserNotFound />;
  }

  const {
    photo_url: profileImage,
    background_image: backgroundImage,
    user_data: bio,
    display_name: profileName,
    user_name: profilePosition,
    social_links,
    profile_color: profileColor,
    email,
    user_data,
  } = profileData;

  const links = social_links ? JSON.parse(social_links) : [];
  const commonProps = {
    profileImage,
    backgroundImage,
    bio,
    profileName,
    profilePosition,
    profileColor,
    links,
    email,
    user_data,
  };

  // Dynamically switch between templates
  switch (selectedTemplate) {
    case "template1":
      return <Template1 {...commonProps} />;
    case "template2":
      return <Template2 {...commonProps} />;
    default:
      return <DefaultTemplate {...commonProps} />;
  }
};

export default UserViewSection;
